import { render, staticRenderFns } from "./DojoLobbyModal.vue?vue&type=template&id=9b143e78&"
import script from "./DojoLobbyModal.vue?vue&type=script&lang=ts&"
export * from "./DojoLobbyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports